import React from "react";
import Marquee from "react-fast-marquee";
import "./Brands.css";
import Common_subHeading from "../../common_components/common_subHeading/Common_subHeading";

function Brands() {
  const brandImages = [
    "/assets/images/home/brands/img_1.webp",
    "/assets/images/home/brands/img_2.webp",
    "/assets/images/home/brands/img_3.webp",
    "/assets/images/home/brands/img_4.webp",
    "/assets/images/home/brands/img_5.webp",
    "/assets/images/home/brands/img_6.webp",
    "/assets/images/home/brands/img_7.webp",
    "/assets/images/home/brands/img_8.webp",
    "/assets/images/home/brands/img_9.webp",
  ];

  return (
    <>
      <section className="Brands">
        <div className="container-fuild">
          <Marquee speed={50} gradient={false}>
            <div className="brand_swiper_holder">
              {brandImages.map((img, i) => (
                <div key={i}>
                  <div className="brands_img_holder">
                    <img src={img} alt="brand" className="brand_img" />
                  </div>
                </div>
              ))}
            </div>
          </Marquee>
        </div>
      </section>
    </>
  );
}

export default Brands;
